
// Dashboard sections render their own inline error state, so the global error toast is suppressed.
const DASHBOARD_REQUEST = { suppressErrorToast: true };

export default function DashboardApi({ makeRequest, buildRequest }) {
	function getDashboardEnquiryMetrics() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Dashboard/enquiries', DASHBOARD_REQUEST))
		);
	}

	function getDashboardCommunicationMetrics() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Dashboard/communications', DASHBOARD_REQUEST))
		);
	}

	function getDashboardTourMetrics() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Dashboard/tours', DASHBOARD_REQUEST))
		);
	}

	function getDashboardCentreStatus() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Dashboard/centre-status', DASHBOARD_REQUEST))
		);
	}

	return {
		getDashboardEnquiryMetrics,
		getDashboardCommunicationMetrics,
		getDashboardTourMetrics,
		getDashboardCentreStatus,
	};
}
